// extracted by mini-css-extract-plugin
export default {"image":"yX-z","loaded":"zX-z"};